import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { MaterialModule } from "./material.module";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { ColorPickerModule } from "ngx-color-picker";
import { NgxDatatableModule } from "@siemens/ngx-datatable";

import {
    WtfMatSidenavHelperDirective,
    WtfMatSidenavTogglerDirective,
} from "../../../directives/core/mat-sidenav-helper/mat-sidenav-helper.directive";
import { WtfPipesModule } from "../../../pipes/core/pipes.module";
import { WtfConfirmDialogComponent } from "../../../../components/confirm-dialog/confirm-dialog.component";
import { WtfCountdownComponent } from "../../../../components/countdown/countdown.component";
import { WtfMatchMedia } from "../../../../services/core/match-media.service";
import { WtfNavbarVerticalService } from "../../../../services/navbar-vertical/navbar-vertical.service";
import { WtfMatSidenavHelperService } from "../../../directives/core/mat-sidenav-helper/mat-sidenav-helper.service";
import { WtfHljsComponent } from "../../../../components/hljs/hljs.component";
import { WtfPerfectScrollbarDirective } from "../../../directives/core/wtf-perfect-scrollbar/wtf-perfect-scrollbar.directive";
import { WtfIfOnDomDirective } from "../../../directives/core/wtf-if-on-dom/wtf-if-on-dom.directive";
import { WtfMaterialColorPickerComponent } from "../../../../components/material-color-picker/material-color-picker.component";
import { WtfTranslationLoaderService } from "../../../../services/core/translation-loader.service";
import { CookieService } from "ngx-cookie-service";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    declarations: [
        WtfMatSidenavHelperDirective,
        WtfMatSidenavTogglerDirective,
        WtfConfirmDialogComponent,
        WtfCountdownComponent,
        WtfHljsComponent,
        WtfIfOnDomDirective,
        WtfPerfectScrollbarDirective,
        WtfMaterialColorPickerComponent,
    ],
    imports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        WtfPipesModule,
        ReactiveFormsModule,
        ColorPickerModule,
        NgxDatatableModule,
    ],
    exports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        WtfMatSidenavHelperDirective,
        WtfMatSidenavTogglerDirective,
        WtfPipesModule,
        WtfCountdownComponent,
        WtfHljsComponent,
        WtfPerfectScrollbarDirective,
        ReactiveFormsModule,
        ColorPickerModule,
        NgxDatatableModule,
        WtfIfOnDomDirective,
        WtfMaterialColorPickerComponent,
        TranslateModule,
    ],
    providers: [
        CookieService,
        WtfMatchMedia,
        WtfNavbarVerticalService,
        WtfMatSidenavHelperService,
        WtfTranslationLoaderService,
    ],
})
export class CoreCommonModule {}
